import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import image from "../../../../../resources/mock-assets/images/downloads/example.png";

export default {
    title: "Components/Teaser Download Document",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-teaser-download-document",
    args: {
        fileInfo: "01.01.2023",
        fileType: "PDF",
        fileSize: "3.5 MB",
        link: "https://www.trumpf.com/en_INT/downloads/123456789.pdf",
        downloadLabel: "Download",
        withImage: true,
    },
    argTypes: {
        fileInfo: {
            control: { type: "text" },
        },
        fileType: {
            control: { type: "text" },
        },
        fileSize: {
            control: { type: "text" },
        },
        link: {
            control: { type: "text" },
        },
        downloadLabel: {
            control: { type: "text" },
        },
        withImage: {
            control: { type: "boolean" },
        },
    },
};

export const Default = {
    render: (args) => html`
        <ux-iws-teaser-download-document
            file-info="${args.fileInfo}"
            file-type="${args.fileType}"
            file-size="${args.fileSize}"
            link="${args.link}"
            download-label="${args.downloadLabel}"
        >
            ${args.withImage
                ? html`
                      <div slot="image">
                          <img alt="This is an alt-text" src="${image}" />
                      </div>
                  `
                : ""}
            <div slot="title">This is the title</div>
            <div slot="description">
                This is the description. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua.
            </div>
        </ux-iws-teaser-download-document>
    `,
};
